import './Footer.css';
export var footerCSS = '_ueufet0-3-8-0';